import React, { useEffect, useState, useRef } from "react";
import { usePartnerContext } from "../../components/Context/PartnerContext";
import { useSnackbar } from "../SnackBar";
import { FormControl, Select, MenuItem, OutlinedInput, Checkbox, ListItemText } from "@mui/material";
import { useBranchContext } from "../../components/Context/BranchContext";
import { useProgressBar } from '../ProgressBar';
import { useNavigate } from "react-router-dom";
const EmployeeEditForm = () => {
    const { updatedembployee, updateEmployee } = usePartnerContext();
    const { showSnackbar } = useSnackbar();
    const { branches, FetchBranches } = useBranchContext();
    const nameRef = useRef();
    const emailRef = useRef();
    const phoneRef = useRef();
    const { showProgress } = useProgressBar();
    const [selectedPosition, setSelectedPosition] = useState("");
    const [specializ, setSpecializ] = useState([]);
    const [selectedBranch, setSelectedBranch] = useState("");
    const [specializationName, setspecializationName] = useState([]);
    const { partners, AddPartners, checkEmailExistance } = usePartnerContext();
    const [allowLogin, setAllowLogin] = useState(false);
    const navigate= useNavigate()
    useEffect(() => {
        FetchBranches();
    }, [FetchBranches]);

    useEffect(() => {
        if (updatedembployee && updatedembployee.length > 0) {
            const employee = updatedembployee[0];
            setSelectedPosition(employee.position || "");
            setSpecializ(employee.specialization || []);
            setspecializationName(employee.specialization || []);
            setSelectedBranch(employee.branchId || "");
        }
    }, [updatedembployee]);

    const handlePositionChange = (event) => {
        setSelectedPosition(event.target.value);
    };

    const handleSpecializationChange = (event) => {
        const {
            target: { value },
        } = event;
        setspecializationName(typeof value === "string" ? value.split(",") : value);
        setSpecializ(value);
    };

    const handleBranch = (event) => {
        setSelectedBranch(event.target.value);
    };

    const addUpdatedEmployee = async () => {
        if (nameRef.current.value.trim() === "" || emailRef.current.value.trim() === "" || phoneRef.current.value.trim() === "") {
            showSnackbar("Employee cannot be blank", "error");
            handleClick();
            return;
        }

        if (!updatedembployee || updatedembployee.length === 0) {
            showSnackbar("Employee data is missing", "error");
            return;
        }
        showProgress(true);
       const p= await updateEmployee({
            id: updatedembployee[0].id,
            name: nameRef.current.value.trim(),
            email: emailRef.current.value.trim(),
            phone: phoneRef.current.value.trim(),
            specialization: specializ,
            position: selectedPosition,
            branchId: selectedBranch,
        });
        showProgress(false);
        showSnackbar("Employee updated successfully", "success");setTimeout(() => {
            navigate(`/editemployee/${p.id}/false`)
        }, 2000);
    };

    // Define style to reduce the width and height of input fields
    const smallInputStyle = {
        width: "300px",  // Reduce the width
        height: "40px",  // Reduce the height
        fontSize: "14px", // Smaller font size
        padding: "5px 10px",
    };
    const[emailformat,setFormat]=useState(false);
    const[isValidEmail,setEmailExists]=useState(false);
    const checkEmail=async()=>{
        const emailRegExp=/^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if(emailRef.current.value!=""){
            if(emailRegExp.test(emailRef.current.value)){
                setFormat(false) 
            }else{
                setFormat(true);
            }
            const resp = await checkEmailExistance(emailRef.current.value);
            setEmailExists(resp)
        }
    };
    const [phoneNumber,setPhoneNumber]=useState('');
    const[isValid,setIsValid]=useState(false);
    const validatePhoneNumber=(e)=>{
        const number=e.target.value.trim();
        const phoneRegExp= /^\u002B9665\d{8}$/;
        if(number!=""){
            if(phoneRegExp.test(number)){
                setIsValid(false);
            }else{
              setIsValid(true);   
            }
        }
    }
    const formRef=useRef([]);
    const handleClick=()=>{
        const formElements=formRef.current.elements;
        for(let element of formElements){
            if((element.tagName==="INPUT" && element.type!='button')|| element.tagName === 'SELECT'){
                if(element.value==""){
                    element.style.borderColor='red';
                }else{
                    element.style.borderColor='';
                }
            }
            
        }
    }
    const emptyFieldCheck=(e)=>{
        if(e.target.value===""){
            e.target.style.borderColor='';
        }else{
            e.target.style.borderColor='';
        }
        
    };

    return (
        <main id="main" className="main">
            <section className="section">
                <nav>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><a href="/partnerservice">Home</a></li>
                        <li className="breadcrumb-item"><a href="/allemployee">Employees</a></li>
                        <li className="breadcrumb-item active"><a href="/employeeadd">New Employee</a></li>
                    </ol>
                </nav>
                <div className="row">
                    <div className="col-lg-12">
                        <div className="card">
                            <div className="card-body">
                                <h5 className="card-title">Edit Employee Details</h5>
                                <form ref={formRef}>
                                    <div className="row mb-3">
                                        <label htmlFor="inputText" className="col-sm-2 col-form-label">Name</label>
                                        <div className="col-sm-10">
                                            <input
                                                type="text"
                                                className="form-control"
                                                style={smallInputStyle}
                                                defaultValue={updatedembployee?.[0]?.name || ""}
                                                ref={nameRef}
                                                onBlur={(e)=>{ emptyFieldCheck(e); }}
                                            />
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <label htmlFor="inputText" className="col-sm-2 col-form-label">Email</label>
                                        <div className="col-sm-10">
                                            <input
                                                type="text"
                                                className="form-control"
                                                style={{borderColor: (isValidEmail === true || emailformat === true) ? 'red' : '',width:'300px'}}
                                                defaultValue={updatedembployee?.[0]?.email || ""}
                                                ref={emailRef}
                                                onBlur={(e)=>{ checkEmail(); emptyFieldCheck(e); }}
                                                
                                            />
                                            {emailformat===true && (<div className="form-text text-danger">{ emailformat===true ? "Invalid Email format":"" }</div>)}
                                            {isValidEmail===true && (<div className="form-text text-danger">{isValidEmail===true ? "Email already exists":""}</div>)}
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <label htmlFor="inputNumber" className="col-sm-2 col-form-label">Phone</label>
                                        <div className="col-sm-10">
                                            <input
                                                type="text"
                                                className="form-control"
                                                style={{borderColor: (isValid===true) ? 'red' : '',width:'300px'}}
                                                defaultValue={updatedembployee?.[0]?.phone || ""}
                                                ref={phoneRef}
                                                onBlur={(e)=>{ 
                                                    setPhoneNumber(e.target.value);
                                                    validatePhoneNumber(e);
                                                    emptyFieldCheck(e); 
                                                    }}
                                            />
                                            {isValid===true && (<div className="form-text text-danger">{isValid===true ? "Invalid phone number. Please check the format.":""}</div>)}
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <label htmlFor="inputNumber" className="col-sm-2 col-form-label">Position</label>
                                        <div className="col-sm-10">
                                            <FormControl fullWidth>
                                                <Select
                                                    value={selectedPosition}
                                                    onChange={handlePositionChange}
                                                    input={<OutlinedInput style={smallInputStyle} />}
                                                >
                                                    <MenuItem value="Supervisor">Supervisor</MenuItem>
                                                    <MenuItem value="Technician">Technician</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <label htmlFor="inputNumber" className="col-sm-2 col-form-label">Specialization</label>
                                        <div className="col-sm-10">
                                            <FormControl fullWidth>
                                                <Select
                                                    multiple
                                                    value={specializ}
                                                    onChange={handleSpecializationChange}
                                                    renderValue={(selected) => selected.join(", ")}
                                                    input={<OutlinedInput style={smallInputStyle} />}
                                                >
                                                    <MenuItem value="Washer">
                                                        <Checkbox checked={specializationName.includes("Washer")} />
                                                        <ListItemText primary="Washer" />
                                                    </MenuItem>
                                                    <MenuItem value="Mechanic">
                                                        <Checkbox checked={specializationName.includes("Mechanic")} />
                                                        <ListItemText primary="Mechanic" />
                                                    </MenuItem>
                                                </Select>
                                            </FormControl>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <label htmlFor="inputNumber" className="col-sm-2 col-form-label">Branch</label>
                                        <div className="col-sm-10">
                                            <FormControl fullWidth>
                                                <Select
                                                    value={selectedBranch}
                                                    onChange={handleBranch}
                                                    input={<OutlinedInput style={smallInputStyle} />}
                                                >
                                                    {branches && branches.length > 0 ? (
                                                        branches.map((branch) => (
                                                            <MenuItem key={branch.id} value={branch.id}>
                                                                {branch.name}
                                                            </MenuItem>
                                                        ))
                                                    ) : (
                                                        <MenuItem disabled>No branches available</MenuItem>
                                                    )}
                                                </Select>
                                            </FormControl>
                                        </div>
                                    </div>
                                    {/* Allow Login Checkbox */}
                                    <div className="row mb-3">
                                        <label className="col-sm-2 col-form-label">Allow Login</label>
                                        <div className="col-sm-6">
                                            <div className="form-check mt-2">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id="allowLoginCheckbox"
                                                    checked={updatedembployee?.[0]?.allowLogin}
                                                    onChange={(e) => setAllowLogin(e.target.checked)}
                                                />
                                                <label className="form-check-label" htmlFor="allowLoginCheckbox">
                                                    Yes, allow this employee to log in
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
    <div className="col-12 d-flex justify-content-end align-items-end" style={{ minHeight: "100px" }}>
        <button
            type="button"
            onClick={addUpdatedEmployee}
            className="btn btn-primary px-3 py-2"
        >
            Save
        </button>
    </div>
</div>

                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    );
};

export default EmployeeEditForm;
